export default function (content, color = 'white') {
  document.body.classList.add('modal-open')
  const overlay = document.createElement('div')
  const modal = document.createElement('div')
  const close = document.createElement('div')
  const inner = document.createElement('div')
  const modals = document.getElementById('modals')
  overlay.classList.add('overlay')
  modal.classList.add('modal')
  modal.classList.add(color)
  close.classList.add('modal__close')
  inner.classList.add('modal__inner')
  modal.appendChild(close)
  inner.appendChild(content)
  modal.appendChild(inner)

  function closeModal () {
    overlay.classList.remove('open')
    document.onkeydown = function (e) {
      e = e || window.event
      if (e.key === 'Escape' || e.key === 'Esc') {
        return false
      }
    }
    if (window.history && window.history.pushState) {
      window.history.pushState(null, null, '/')
    }
    setTimeout(function () {
      if (content.id.length !== 0) {
        modals.appendChild(content)
      }
      document.body.removeChild(overlay)
      document.body.classList.remove('modal-open')
    }, 200)
  }
  let offset = 128
  if (content.id === 'youtube') {
    offset = 0
    modal.classList.add('video')
  }

  overlay.appendChild(modal)
  document.body.appendChild(overlay)

  const contentHeight = content.scrollHeight
  // console.log(contentHeight)
  if (window.innerWidth > 1024 && contentHeight < window.innerHeight / 100 * 70) {
    modal.style.height = contentHeight + offset + 'px'
  } else if (window.innerWidth >= 1024 && contentHeight < window.innerHeight / 100 * 95) {
    modal.style.height = contentHeight + 64 + 'px'
  }

  setTimeout(function () {
    overlay.classList.add('open')
  }, 10)

  // Events

  close.onclick = function () {
    closeModal()
  }
  overlay.onclick = function () {
    closeModal()
  }
  document.onkeydown = function (e) {
    e = e || window.event
    if (e.key === 'Escape' || e.key === 'Esc') {
      closeModal()
    }
  }
  modal.onclick = function (e) {
    e.stopPropagation()
  }
}



// WEBPACK FOOTER //
// ./app/scripts/modal.js